module.exports = __webpack_public_path__ + "img/ecosystem_01_outline.3d75522a.svg";